module.exports = __webpack_public_path__ + "img/badge-black.3cf5cd84.png";